import { useEffect, useMemo, useState } from "react";
import { Box, Paper, Tab, Tabs, Typography } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import PersonIcon from "@mui/icons-material/Person";
import { jwtDecode } from "jwt-decode";

import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import HospitalEditForm from "./hospitalEditForm";
import ProfileEditForm from "./profileEditForm";

function getStoredToken(key) {
  const value = localStorage.getItem(key);
  if (!value) return null;

  try {
    return JSON.parse(value);
  } catch (err) {
    return value;
  }
}

function TabPanel({ children, value, index }) {
  if (value !== index) return null;
  return <Box sx={{ pt: 3 }}>{children}</Box>;
}

export default function ProfilePage() {
  const [tab, setTab] = useState(0);

  const currentUser = useMemo(() => {
    try {
      const token = getStoredToken("accessToken");
      return token ? jwtDecode(token) : null;
    } catch (err) {
      return null;
    }
  }, []);

  const isVet = currentUser?.roleId === 2;

  useEffect(() => {
    if (isVet && tab === 1) setTab(0);
  }, [isVet, tab]);

  return (
    <>
      <AppBreadcrumbs />

      <Box sx={{ maxWidth: 1080, mx: "auto", mt: 3 }}>
        <Box sx={{ mb: 2 }}>
          <Typography variant="h5" fontWeight={700}>
            ตั้งค่า
          </Typography>
          <Typography color="text.secondary" sx={{ mt: 0.5 }}>
            จัดการข้อมูลบัญชีผู้ใช้และข้อมูลโรงพยาบาลที่แสดงในระบบ
          </Typography>
        </Box>

        <Paper
          elevation={0}
          sx={{
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 2,
            p: { xs: 2, md: 3 },
          }}
        >
          <Tabs
            value={tab}
            onChange={(e, newValue) => setTab(newValue)}
            variant="fullWidth"
            sx={{
              borderBottom: "1px solid",
              borderColor: "divider",
              "& .MuiTab-root": {
                minHeight: 52,
                textTransform: "none",
                fontWeight: 700,
              },
            }}
          >
            <Tab icon={<PersonIcon />} iconPosition="start" label="ข้อมูลผู้ใช้" />
            {!isVet && (
              <Tab
                icon={<BusinessIcon />}
                iconPosition="start"
                label="ข้อมูลโรงพยาบาล"
              />
            )}
          </Tabs>

          <TabPanel value={tab} index={0}>
            <ProfileEditForm currentUser={currentUser} />
          </TabPanel>

          {!isVet && (
            <TabPanel value={tab} index={1}>
              <HospitalEditForm currentUser={currentUser} />
            </TabPanel>
          )}
        </Paper>
      </Box>
    </>
  );
}
